import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizeGuard {
  constructor(private _authService: AuthService) {}

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    return this._authService.authorise().pipe(take(1));
  }
}
